module.exports = __webpack_public_path__ + "media/images/dogs/chocolate-toxic-calculator-how-much-chocolate-is-toxic-for-your-dogs.jpg";